import React, { Fragment } from 'react'
import cx from 'classnames'
import moment from 'moment'
import { useMemo, useState, useCallback } from 'sb-hooks'

import Box from 'components/layout/Box/Box'
import { Tabs } from 'components/controls'
import Loader from 'components/ui/Loader/Loader'
import CardTitle from 'components/dashboard/CardTitle/CardTitle'
import CardContainer from 'components/dashboard/CardContainer/CardContainer'

import Date from '../Card/Date/Date'
import PeriodsForm from '../PeriodsForm/PeriodsForm'

import s from './CardWithGraph.scss'


const CardWithGraph = ({ children, title, color, date, loading = 'white', withPeriodTab = true, selectedTab, tabsList, onSelect }) => {
  const defaultTabs = tabsList || [
    'сегодня',
    'неделя',
    'месяц',
  ]

  const fullTabs = [
    ...defaultTabs,
    'за период',
  ]

  const [ { selected, isPeriodsVisible }, setState ] = useState({
    selected: selectedTab >= 0 ? selectedTab : 0,
    isPeriodsVisible: false,
    from: null,
    to: null,
  })

  const unSelectTab = useCallback(() => {
    setState({ selected: 0, isPeriodsVisible: false })
    onSelect(0)
  }, [ onSelect ])

  const setPeriod = useCallback(({ from, to }) => {
    setState({ from, to, isPeriodsVisible: false })
    onSelect({
      from: moment(from, 'DDMMYYYY').format('YYYY-MM-DD'),
      to: moment(to, 'DDMMYYYY').format('YYYY-MM-DD'),
    })
  }, [ onSelect ])

  const tabs = useMemo(() => withPeriodTab ? fullTabs : defaultTabs, [ withPeriodTab ])

  const selectTab = useCallback((newSelected) => {
    setState({ selected: newSelected })

    if (tabs[newSelected] === 'за период') {
      setState({ isPeriodsVisible: true })

      return
    }

    onSelect(newSelected)
  }, [ tabs, onSelect ])

  return (
    <CardContainer
      className={cx(s.card, {
        [s.blue]: color === 'blue',
        [s.white]: color === 'white',
      })}
    >
      <CardTitle
        title={title}
        color={color === 'blue' ? 'white-80' : 'blueDark'}
      />
      {
        isPeriodsVisible ? (
          <PeriodsForm
            color="blue"
            onCancel={unSelectTab}
            onSubmit={setPeriod}
          />
        ) : (
          <Fragment>
            <div className={s.graph}>
              {
                loading ? (
                  <Loader color={color === 'blue' ? 'white' : 'blue'} />
                ) : (
                  children
                )
              }
            </div>
            {
              Boolean(date) && (
                <Box pb="8">
                  <Date
                    color={color === 'blue' ? 'white-80': 'blueDark'}
                    from={date.from}
                    to={date.to}
                  />
                </Box>
              )
            }
            {
              Boolean(onSelect) && (
                <Tabs
                  tabs={tabs}
                  color={color === 'blue' ? 'white-80' : 'blueDark'}
                  selected={selected}
                  onSelect={selectTab}
                />
              )
            }
          </Fragment>
        )
      }
    </CardContainer>
  )
}


export default CardWithGraph
